/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var jove__app__candidate_view__model__SortByColumnEnum;

(function (jove__app__candidate_view__model__SortByColumnEnum) {
  jove__app__candidate_view__model__SortByColumnEnum["CREATED_AT"] = "created_at";
  jove__app__candidate_view__model__SortByColumnEnum["UPDATED_AT"] = "updated_at";
  jove__app__candidate_view__model__SortByColumnEnum["FULL_NAME"] = "full_name";
  jove__app__candidate_view__model__SortByColumnEnum["EMAIL"] = "email";
  jove__app__candidate_view__model__SortByColumnEnum["VALIDATION_STATUS"] = "validation_status";
  jove__app__candidate_view__model__SortByColumnEnum["JOB_TITLE"] = "job_title";
  jove__app__candidate_view__model__SortByColumnEnum["START_DATE"] = "start_date";
  jove__app__candidate_view__model__SortByColumnEnum["END_DATE"] = "end_date";
  jove__app__candidate_view__model__SortByColumnEnum["INVITATION_STATUS"] = "invitation_status";
})(jove__app__candidate_view__model__SortByColumnEnum || (jove__app__candidate_view__model__SortByColumnEnum = {}));